import React from 'react';
import { Tabs } from 'antd';
import PotionRecepyWiki from '../../agnoia/alchemy/wiki/PotionRecepyWiki';
import HerbWiki from '../../agnoia/alchemy/wiki/HerbWiki';
import PotionWiki from '../../agnoia/alchemy/wiki/PotionWiki';

const { TabPane } = Tabs;

export default function AgnoiaAlchemyWiki() {

    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Potions" key="1">
                <PotionWiki />
            </TabPane>
            <TabPane tab="Herb List" key="2">
                <HerbWiki/>
            </TabPane>
            <TabPane tab="Recepies" key="3">
                <PotionRecepyWiki />
            </TabPane>
        </Tabs>
    )
}